import {mask} from 'vue-the-mask';
import {mapActions, mapGetters} from 'vuex';

export default {
    directives: {mask},
    props: {
        paymentMethod: {
            type: Object,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    inject: ['$validator'],
    computed: {
        ...mapGetters('checkout', [
            'checkout',
            'total',
            'isRequestProcessing',
            'getAvailablePaymentMethods',
            'getAvailableDesktopPaymentMethods',
        ]),
        paymentMethodName() {
            return this.paymentMethod.method_name;
        },
        paymentMethodType() {
            return this.paymentMethod.type;
        },
        paymentType: {
            get() {
                return this.$store.state.payment.payment_type;
            },
            set(p) {
                this.$store.commit('payment/setPaymentType', p);
            },
        },
        paymentData: {
            get() {
                return this.$store.state.payment.payment_data;
            },
            set(p) {
                this.$store.commit('payment/setPaymentData', p);
            },
        },
        isRequestProcessing: {
            get() {
                return this.$store.state.checkout.isRequestProcessing;
            },
            set(p) {
                this.$store.commit('checkout/setRequestProcessing', p);
            },
        },
        checkoutTitle() {
            return this.$store.state.checkout.config.title;
        },
        shipping() {
            return this.$store.state.shipping;
        },
        phoneNumber() {
            return this.$store.state.contact.phone;
        },
        isPaymentTypeAlreadySet() {
            return this.paymentType !== null &&
                typeof this.getAvailablePaymentMethods.find(
                    pm => pm.method_name === this.paymentType) !== 'undefined';
        },
    },
    methods: {
        ...mapActions('checkout', [
            'fetchCheckout',
            'updatePaymentMethod',
        ]),
        async prePaymentRequest() {
            return await new Promise((resolve, reject) => {
                return resolve(true);
            });
        },
        handlePaymentIsNotSupported() {
            const newPaymentMethod = Object.assign({}, this.paymentMethod);
            newPaymentMethod.is_available = false;
            this.updatePaymentMethod({
                oldValue: this.paymentMethod,
                newValue: newPaymentMethod,
            });
        },
        setRequestStatus(status) {
            this.isRequestProcessing = status;
        },
        showPaymentErrorMessage() {
            this.$notify.error({
                title: 'Error',
                message: 'The data entered does not match your billing information. Please re-enter the correct billing information',
            });
        },
        showPaymentCanceledMessage() {
            this.$notify.info({
                title: 'Info',
                message: 'Your payment was cancelled',
            });
        },
    },
};
